export default {
  setLoading (state, isLoading) {
    state.loading = isLoading
  },
  setDecks (state, decks) {
    state.decks = decks
  }
}
